<template>
	<div class="Loginpage">
		<el-row class="Loginrow" type="flex" justify="center">
			<el-col :span="20">
				<el-input v-model="User.name" placeholder="姓名" v-on:keyup.enter.native="Login"></el-input>
			</el-col>
		</el-row>
		<el-row class="Loginrow" type="flex" justify="center">
			<el-col :span="20">
				<el-input v-model="User.nickname" placeholder="专业" v-on:keyup.enter.native="Login"></el-input>
			</el-col>
		</el-row>
		<el-row class="Loginrow" type="flex" justify="center">
			<el-col :span="20">
				<el-input v-model="User.number" placeholder="学号" v-on:keyup.enter.native="Login"></el-input>
			</el-col>
		</el-row>
		<el-row class="Loginrow">
			<el-col :span="8" :offset="8">
				<el-button type="primary" @click="Login">登入 Login</el-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>
// import Api from "@/components/Api"
import title from "../assets/title.png"
export default {
	name: "Login",
	data() {
		return {
			User: {
				name: "",
				nickname: "",
				number: "",
				score: 0
			},
			title
		}
	},
	methods: {
		Login() {
			if (this.name === "" || this.nickname === "" || this.number === "") {
				this.$message.error("请完整输入信息!")
			} else {
				this.$store.commit("Login", this.User)
				this.$message.success("登入成功！")
			}
			
		}
	}
}
</script>

<style scoped>
.Loginrow {
	margin: 3%;
}
</style>
